// extracted by mini-css-extract-plugin
export var details = "_e1-0";
export var inspectorPopover = "_e1-1";